<template>
  <div class="wrapper-content w-100" id="decretos-movements">
    <h1>{{ titulo }}</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <div class="estado-decreto">
      <h2>{{decretoTitulo}}</h2>
      <a-timeline
        mode="alternate"
        v-if="movimientos.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movimientos.items"
          :key="index"
          :color="m.color || 'gray'"
        >
          <a-icon
            v-if="m.icono"
            slot="dot"
            :type="m.icono"
            style="font-size: 22px;"
          />
          <div class="datos d-flex flex-column mx-2">
            <span class="accion" :style="{color: titleColor[m.color]}">{{ m.accion }}</span>
            <span class="usuario">{{ m.usuario }}</span>
            <span>{{ m.secretaria }}</span>
            <span>{{ m.fecha }}</span>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <hr>
    <LmButton
      id="btn-cancel"
      type="button"
      buttonClass="btn-secondary"
      :isProcessing="formIsProcessing"
      value="Volver"
      @click.native="goBackBtn"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
    />
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'

import 'moment/locale/es'
moment.locale('es')

export default {
  data () {
    return {
      titulo: 'Historial',
      decretoTitulo: `Decreto #${this.$route.params.id}`,
      isLoading: false,
      formIsProcessing: false,
      movimientos: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff'
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    goBackBtn () {
      this.$router.go(-1)
    }
  },
  watch: {
    movimientos: {
      handler (val, oldVal) {
        this.movimientos = val
        this.movimientos.items.forEach(i => (i.fecha = moment(i.fecha).format('DD-MM-YYYY HH:mm:ss')))
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      const movimientosPromise = commonsApi.getItemDetail({
        path: 'decretos/movements/',
        id: this.$route.params.id
      })
      const decretoPromise = commonsApi.getItemDetail({
        path: 'decretos/props/',
        id: this.$route.params.id
      })

      const [movimientosRes, decretoRes] = await Promise.all([movimientosPromise, decretoPromise])

      this.movimientos = movimientosRes.movements
      this.decretoTitulo = decretoRes.titulo
    } catch (error) {

    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
#decretos-movements
  .estado-decreto
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
    .datos
      .accion
        font-weight: bold
      .usuario
        font-weight: bold
</style>
